<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-header">{{tableData.name}}</div>
					<div class="card-body">
						<div class="container h-100">
							<div class="row h-100 justify-content-center align-items-center">
								<vimeo-player class="video-vimeo" v-if="videoID !== null" ref="player" :video-id="videoID" :options="options" @ready="onReady">
								</vimeo-player>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
	data () {
		return {
			id: '',
			tableData: [],
			videoID: null,
			options: {
				loop: true,
				title: false,
				transparent: false,
				maxheight: 900,
				maxwidth: 1200
			},
			playerReady: false
		}
	},
	components: { vueVimeoPlayer },
	created () {
		this.id = parseInt(this.$route.params.id)
		this.getLesson()
	},
	methods: {
		getLesson () {
			this.$store.commit('CALL_API_ON')
			this.$http.get(this.$store.state.apiURL + '/v1/lessons/' + this.id, {}, {
			}).then(function (response) {
				this.tableData = response.body
				this.videoID = this.tableData.vimeo_id
				this.$store.commit('CALL_API_OFF')
			}, function (response) {
			})
		},
		onReady () {
			this.playerReady = true
		},
		play () {
			this.$refs.player.play()
		},
		stop () {
			this.$refs.player.stop()
		}
	}
}
</script>
<style>
.video-vimeo {
  width: 1200px;
  position: relative;
  padding-bottom: 56.25%;
  /*пропорции видео 16:9 */
  padding-top: 25px;
  height: 0;
}

.video-vimeo iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instruction/lesson.vue